
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import InfoBoxWarning from '@components/shared/ui/InfoBoxWarning.vue';
import SettingsTitleBar from '@components/settings/SettingsTitleBar.vue';
import SettingsPanel from '@components/settings/SettingsPanel.vue';
import AppPage from '@components/new-styleguide/AppPage.vue';
import AppHeader from "@components/new-styleguide/AppHeader.vue";
import AppContent from '@components/new-styleguide/AppContent.vue';
import { LoadState } from '@/utils/types';
import { Tag } from '@/generated-clients/myTrips';
import AppListItem, { ListItem } from '@components/new-styleguide/AppListItem.vue';

const SettingsModule = namespace('Settings');

@Component({
  name: 'TagsOverview',
  components: {
    SettingsPanel,
    AppListItem,
    InfoBoxWarning,
    AppContent,
    AppPage,
    AppHeader,
    SettingsTitleBar
  }
})
export default class TagsOverview extends Vue {
  @SettingsModule.Action('fetchTags')
  private fetchTags;

  @SettingsModule.Getter('getTags')
  private tags: Tag[];

  @SettingsModule.Getter('getTagsStatus')
  private tagsStatus: LoadState;

  private created() {
    this.fetchTags();
  }

  get backButton() {
    return { text: 'Zurück zu Anpassen', location: { name: 'mySettings' } };
  }

  get addButton() {
    return { text: 'Neue Kategorie anlegen', location: { name: 'tagsAdd' } };
  }

  get tagsHeaderText() {
    return 'Kategorien können Fahrten manuell oder durch Regeln zugeordnet werden. Dadurch können Fahrten kategorisiert, und in der Statistik verglichen werden.';
  }

  get createItem(): ListItem {
    return { title: 'Neue Kategorie anlegen', tagIcon: { value: 'tag_plus', color: '#FFDC00', fill: 'black' }, location: { name: 'tagsAdd' } };
  }

  get tagItems(): ListItem[] {
    if (this.isLoading) {
      return [];
    }

    return this.tags.map(
      t => ({ id: t.id, title: t.name, tagIcon: { value: t.iconName, color: t.color, fill: 'white' }, location: { name: 'tagEdit', params: { id: t.id.toString() } }, hoverText: 'Kategorie bearbeiten' })
    );
  }

  get errorLoading() {
    return this.tagsStatus === LoadState.Error;
  }

  get isLoading() {
    return this.tagsStatus === LoadState.Loading;
  }
}
